var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lb-btn-container", attrs: { id: "open-button" } },
    [
      _c(
        "div",
        {
          staticClass: "grey-outline-pill-button",
          on: { click: _vm.goBackward }
        },
        [_vm._v("Назад")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "red-pill-button-of-hate go-next extra-left-margin",
          on: { click: _vm.openDesign }
        },
        [_vm._v("Товары")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }